// extracted by mini-css-extract-plugin
module.exports =  {"root":"MTZ4Eh","title":"nY2sBx","dropdown":"tcTuTT","optionDetails":"Dm3Kol","optionPrice":"hQuQsR","optionsContainer":"QoU0fE"};